module.exports = __webpack_public_path__ + "img/logo_avenue.8f965bb7.svg";